const SvgClean = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 64 64">
    <path stroke="#000" strokeWidth={2} d="m32 2 4 18 16 4-16 4-4 18-4-18-16-4 16-4ZM50 40l2 8 8 2-8 2-2 8-2-8-8-2 8-2ZM10 10l1 4 5 2-5 2-1 4-1-4-5-2 5-2Z" />
  </svg>;
export default SvgClean;